import React from 'react'
import RadioGroupField, {
  RadioButtonGroupField,
} from '../../formFields/radioGroupField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <RadioGroupField {...fieldProps} />
))

export const RadioButtonGroupFieldReduxFormWrapper = reduxFormFieldWrapper(
  fieldProps => <RadioButtonGroupField {...fieldProps} />
)
